import { createContext, FC, useContext } from 'react';
import { createIntl } from './createIntl';
import { IntlShape } from './types';

export const IntlContext = createContext<IntlShape | null>(null);

type Props = {
    messages?: Record<string, string>;
    locale: string;
    defaultLocale?: string;
};

export function useIntl(): IntlShape {
    const intl = useContext(IntlContext);

    if (!intl) {
        throw new Error(
            '[dibs-react-intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.'
        );
    }

    return intl;
}

export const IntlProvider: FC<Props> = ({ messages, locale, children }) => {
    const intl = createIntl({ locale, messages, defaultLocale: 'en-US' });
    return <IntlContext.Provider value={intl}>{children}</IntlContext.Provider>;
};
